
const init = () => {
    carouselInstancing();

    // Header class, Phone cta class
    const header = new Header();
    const phoneCta = new PhoneCTA();

    // generic handler for fadeIn / fadeOut
    $('[data-target]').on('click', genericFade);

    // Anchors
    $('.is-anchor a').on('click', anchors);

    // Input masks
    maskInstancing();

    // iframe handling for pagespeed
    deferIframes();

    // Handle Services Modals
    initModals();

    // SendMail
    sendMail();

    // Whats Tracking
    tracker();
}

// window load binds
window.onload = init;

const DOMLoaded = () => {
    // these are not always necessary but sometimes they fuck with ya
    if (helpers.iOS) {
        document.querySelector('html').classList.add('ios');
    } else if (helpers.IE()) {
        document.querySelector('html').classList.add('ie');
    }
}

// domcontent binds
document.addEventListener('DOMContentLoaded', DOMLoaded);